export enum DRAWER_CONTEXT {
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  EDIT_PRODUCT = 'EDIT_PRODUCT',
  CREATE_LOCATION = 'CREATE_LOCATION',
  EDIT_LOCATION = 'EDIT_LOCATION',
  CREATE_STOCK = 'CREATE_STOCK',
  EDIT_STOCK = 'EDIT_STOCK',
  CREATE_TAG = 'CREATE_TAG',
  EDIT_TAG = 'EDIT_TAG',
  CREATE_STAGE = 'CREATE_STAGE',
  EDIT_STAGE = 'EDIT_STAGE',
  CREATE_ORDER = 'CREATE_ORDER',
  EDIT_ORDER = 'EDIT_ORDER',
  CREATE_CUSTOMER = 'CREATE_CUSTOMER',
  EDIT_CUSTOMER = 'EDIT_CUSTOMER',
  CREATE_SUPPLIER = 'CREATE_SUPPLIER',
  EDIT_SUPPLIER = 'EDIT_SUPPLIER',
  CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER',
  EDIT_PURCHASE_ORDER = 'EDIT_PURCHASE_ORDER',
}
